export default "__VITE_ASSET__DrD5PsBl__"